import { render, staticRenderFns } from "./planB.vue?vue&type=template&id=5b45f63a&scoped=true&"
import script from "./planB.vue?vue&type=script&lang=js&"
export * from "./planB.vue?vue&type=script&lang=js&"
import style0 from "./planB.vue?vue&type=style&index=0&id=5b45f63a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b45f63a",
  null
  
)

export default component.exports